import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {IntegratedInstanceData} from "./integrated-instance.data";

@Injectable()
export class IntegratedInstanceEntityModel extends EntityModel<IntegratedInstanceData> {

    constructor(injector: Injector) {
        super(injector, IntegratedInstanceData);
    }


    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }

    override canGetEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }

    override canUpdateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }

    override isEntityCloneable(): boolean {
        return false;
    }
}
